var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 4.5L19.5 19.5M19.5 4.5L4.5 19.5","stroke":"#EA5265","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
